/**
 * Tags are used to for Frontends to filter what cameras to display and use
 */
export var CameraTag;
(function (CameraTag) {
    CameraTag["All"] = "All";
    CameraTag["Exterior"] = "Exterior";
    CameraTag["Interieur"] = "Interieur";
    CameraTag["ExternalScreen"] = "ExternalScreen";
    CameraTag["Navigatable"] = "Navigatable";
    CameraTag["Moodboard"] = "Moodboard";
    CameraTag["MiWi"] = "MiWi";
    CameraTag["MTT"] = "MTT";
})(CameraTag || (CameraTag = {}));
//# sourceMappingURL=camera-tags.js.map